import AuthorizeTaskApi from '../api/authorizeTaskApi';
import interviewTaskApi from '../api/interviewTaskApi';

const authorizeApi = AuthorizeTaskApi.create();
const interviewApi = interviewTaskApi.create();
export const resetAuthorizeForTicket = async (ticketId, isPrimary) => {
    var response = await authorizeApi.resetAuthorizeTask(ticketId, isPrimary);
    if (response && response.ok && response.data) {
        return response.data;
    } else {
        return null;
    }
}

export const resetInterviewForTicket = async (ticketId) => {
    var response = await interviewApi.resetInterviewTask(ticketId);
    if (response && response.ok && response.data) {
        return response.data;
    } else {
        return null;
    }
}

export const repairMissingInterviewFile = async (ticketId) => {
    var response = await interviewApi.repairMissingInterviewFile(ticketId);
    if (response && response.ok && response.data) {
        return response.data;
    } else {
        return null;
    }
}